<template>
  <slot v-bind="{ visible, tags }" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProductsStore } from '@/stores'
const store = useProductsStore()

export interface Props {
  tags: string[]
}

const props = defineProps<Props>()

const visible = computed(() => {
  if (store.filter === 'all') {
    return true
  }
  return props.tags.includes(store.filter)
})
</script>
